import { BUTTON_VARIANT } from './constants.js';

var defaultProps = {
  disabled: false,
  fluidWidth: false,
  labelText: '',
  icon: null,
  onBlur: function onBlur() {
    return null;
  },
  onClick: function onClick() {
    return null;
  },
  onKeyPress: function onKeyPress() {
    return null;
  },
  leftIcon: null,
  tabIndex: 0,
  variant: BUTTON_VARIANT.DEFAULT,
  containerProps: {},
  as: 'button',
  type: 'button'
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
